import { ChangeEventHandler, FocusEvent, FocusEventHandler, useRef } from 'react';
interface SearchInputProps {
  searchString: string;
  setSearchString: ChangeEventHandler<HTMLInputElement>;
  setHighlightedItem: Function;
  eraseResults: Function;
  autoFocus: boolean;
  onFocus: FocusEventHandler<HTMLInputElement>;
  placeholder: string;
  showIcon: boolean;
  maxLength: number;
  theme: any;
}

export default function SearchInput({
  searchString,
  setSearchString,
  setHighlightedItem,
  eraseResults,
  autoFocus,
  onFocus,
  placeholder,
  maxLength,
  theme,
}: SearchInputProps) {
  const ref = useRef<HTMLInputElement>(null);

  let manualFocus = true;

  const handleOnFocus = (event: FocusEvent<HTMLInputElement>) => {
    manualFocus && onFocus(event);
  };

  const maxLengthProperty = maxLength ? { maxLength } : {};

  return (
    <div className="search-input pl-3">
      <input
        type="text"
        ref={ref}
        spellCheck={false}
        value={searchString}
        onChange={setSearchString}
        onFocus={handleOnFocus}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onBlur={() => eraseResults()}
        className="pl-5"
        onKeyDown={(event) => setHighlightedItem({ event })}
        data-test="search-input"
        {...maxLengthProperty}
      />

      {/* Styled JSX block */}
      <style jsx>{`
        .search-input {
          min-height: ${theme.height};
          width: 100%;
          display: flex;
          align-items: center;
        }
        .search-input input {
          width: 100%;
          padding: 0 0 0 13px;
          border: none;
          outline: none;
          background-color: rgba(0, 0, 0, 0);
          font-size: inherit;
          font-family: inherit;
          color: ${theme.color};
          padding-right: 50px;
        }
        .search-input input::placeholder {
          color: ${theme.placeholderColor};
          opacity: 1;
        }
      `}</style>
    </div>
  );
}
